'use client';

import React from 'react';
import { Radio, Music2, Mic2, Globe2 } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const FEATURES = [
  {
    icon: Radio,
    title: 'Transmisión 24/7',
    desc: 'Música latina sin parar, todos los días del año. Nunca hay silencio en Rumbaexplosions.',
    color: '#ef4444',
  },
  {
    icon: Mic2,
    title: 'DJ Jorge en Vivo',
    desc: 'Nuestro DJ virtual anuncia cada canción con energía y pasión. Siempre presente.',
    color: '#fb923c',
  },
  {
    icon: Music2,
    title: 'Los Mejores Éxitos',
    desc: 'Salsa, cumbia, vallenato, merengue y más. La mejor selección de música latina.',
    color: '#a855f7',
  },
  {
    icon: Globe2,
    title: 'Noticias Globales',
    desc: 'Boletines informativos al mediodía. Mantente informado mientras disfrutas la música.',
    color: '#06b6d4',
  },
];

export default function RumbaAboutSection() {
  return (
    <section className="px-6 md:px-12 py-16 relative overflow-hidden">
      {/* Background accent */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at 50% 0%, rgba(239,68,68,0.06) 0%, transparent 70%)',
        }}
      />

      <div className="relative max-w-5xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-12">
          <p
            className="text-xs font-bold uppercase tracking-widest mb-3"
            style={{ color: '#fb923c' }}
          >
            Sobre Nosotros
          </p>
          <h2 className="text-3xl md:text-4xl font-black text-foreground mb-4" style={{ letterSpacing: '-0.02em' }}>
            Más que una radio,<br />
            <span style={{ color: '#ef4444' }}>una explosión de sabor</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto text-base leading-relaxed">
            Desde Medellín para el mundo. Rumbaexplosions nació con una misión: llevar la energía
            de la música latina a cada rincón del planeta, sin parar, sin filtros.
          </p>
        </div>

        {/* Asymmetric bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Large featured card */}
          <div
            className="md:row-span-2 relative overflow-hidden rounded-2xl p-8 flex flex-col justify-between"
            style={{
              background: 'linear-gradient(135deg, rgba(239,68,68,0.15) 0%, rgba(251,146,60,0.08) 100%)',
              border: '1px solid rgba(239,68,68,0.2)',
              minHeight: '280px',
            }}
          >
            <div
              className="absolute top-0 right-0 w-40 h-40 rounded-full pointer-events-none"
              style={{
                background: 'radial-gradient(circle, rgba(239,68,68,0.2) 0%, transparent 70%)',
                transform: 'translate(30%, -30%)',
              }}
            />
            <div>
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center mb-6"
                style={{ background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)' }}
              >
                <Radio size={22} style={{ color: '#ef4444' }} />
              </div>
              <h3 className="text-2xl font-black text-foreground mb-3" style={{ letterSpacing: '-0.02em' }}>
                Transmisión 24/7
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                Música latina sin parar, todos los días del año. Nunca hay silencio en Rumbaexplosions.
                Desde las primeras horas de la mañana hasta la madrugada, siempre hay ritmo.
              </p>
            </div>
            <div className="mt-6 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-red-500 live-pulse" />
              <span className="text-xs font-bold text-red-400 tracking-wider uppercase">Siempre en vivo</span>
            </div>
          </div>

          {/* Smaller cards */}
          {FEATURES?.slice(1)?.map((feat) => {
            const Icon = feat?.icon;
            return (
              <div
                key={feat?.title}
                className="relative overflow-hidden rounded-2xl p-6 flex items-start gap-4"
                style={{
                  background: `linear-gradient(135deg, ${feat?.color}12 0%, ${feat?.color}06 100%)`,
                  border: `1px solid ${feat?.color}25`,
                }}
              >
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5"
                  style={{ background: `${feat?.color}18`, border: `1px solid ${feat?.color}30` }}
                >
                  <Icon size={18} style={{ color: feat?.color }} />
                </div>
                <div>
                  <h3 className="text-base font-bold text-foreground mb-1">{feat?.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{feat?.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
